import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      paddingBottom: 80,
      [theme.breakpoints.down(Sizes.desktop)]: {
        paddingBottom: 40,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        paddingBottom: 30,
      },
    },
    title: {
      marginTop: 15,
      marginBottom: 25,
      fontSize: 32,
      lineHeight: '50px',
      fontWeight: 700,
      [theme.breakpoints.down(Sizes.desktop)]: {
        fontSize: 24,
        lineHeight: '36px',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
        lineHeight: '24px',
        marginBottom: 15,
      },
    },
    subTitle: {
      fontSize: 16,
      [theme.breakpoints.down(Sizes.desktop)]: {
        fontSize: 14,
      },
    },
    formBox: {
      width: '100%',
      paddingTop: 40,
      [theme.breakpoints.down(Sizes.desktop)]: {
        paddingTop: 30,
      },
    },
    fieldsBox: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    fieldWrap: {
      width: '48%',
      marginBottom: 15,
      [theme.breakpoints.down(Sizes.desktop)]: {
        width: '100%',
      },
    },
    fieldWrapCustomer: {
      width: '48%',
      marginBottom: 15,
      [theme.breakpoints.down(Sizes.desktop)]: {
        width: '48%',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
      },
    },
    fullWidthFieldWrap: {
      marginBottom: 15,
    },
    formFooter: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: 30,
      [theme.breakpoints.down(Sizes.desktop)]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
    },
    contactBox: {
      padding: '0 25px',
      '& a': {
        color: colorVariables.navy,
      },
      [theme.breakpoints.down(Sizes.desktop)]: {
        marginTop: 40,
        width: '100%',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 0,
      }
    },
    contactBoxTitle: {
      fontSize: 16,
      fontWeight: 600,
      width: 200,
      [theme.breakpoints.down(Sizes.desktop)]: {
        fontSize: 14,
      },
    },
    sendButton: {
      [theme.breakpoints.down(Sizes.desktop)]: {
        alignSelf: 'center',
      },
    },
    row: {
      marginBottom: 15,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(Sizes.mobile)]: {
        display: 'block',
      }
    },
    rowBorder: {
      border: '1px solid #98A5B74D',
      padding: 10,
      borderRadius: 10,
      justifyContent: 'flex-start',
      alignItems: 'baseline',
      '& svg': {
        marginRight: 10,
        alignSelf: 'anchor-center',
      }
    },
    opLogo: {
      width: 18,
    },
    supportText: {
      margin: '0 15px 0 10px',
      fontWeight: 600,
      [theme.breakpoints.down(Sizes.mobile)]: {
        margin: '0 5px 0 5px',
      }
    },
    emailLink: {
      color: `${colorVariables.blue} !important`,
      textDecoration: 'underline',
    },
    phoneText: {
      color: colorVariables.grey60,
      marginRight: 20,
    },
    newLine: {
      height: 5,
    }
  }),
);
